/* eslint-disable */
import * as React from "react";
// Custom components

// Assets

import { useDispatch, useSelector } from "react-redux";
import {
  selectList,
  selectLoading,
  selectPageNo,
  selectPageSize,
} from "./redux/selector";

import { CopyIcon } from "@chakra-ui/icons";
import {
  Box,
  Flex,
  FormControl,
  IconButton,
  Image,
  SimpleGrid,
} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import Card from "../../../components/card/Card";
import MultiFileUpload from "../../../components/Common/CustomUpload/MultiFileUpload";
import IsLoading from "../../../components/Common/IsLoading";
import { path } from "../../../utils/Api";
import { actions } from "./redux/slice";

export default function Index() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const pageNo = useSelector(selectPageNo);
  const pageSize = useSelector(selectPageSize);
  const list = useSelector(selectList);

  React.useEffect(() => {
    dispatch(actions.doGetList());
    return () => {};
  }, [pageNo, pageSize]);

  const loader = useSelector(selectLoading);

  const handleDeleteFile = (name: string) => {
    // dispatch(actions.doRemoveImages({ name: name, index: index }));
  };
  const handleChangeUploadField = (name: string, val: any) => {
    dispatch(
      actions.uploadImage({
        fileName: val,
        callback() {
        },
      })
    );
  };
  const copyToClipboard = (code: string) => {
    const fullUrl = `${code}`;
    navigator.clipboard.writeText(fullUrl).then(
      () => {
        toast.info("Linked Copied");
      },
      (err) => {
        toast.error("Linked Copied failed");
      }
    );
  };
  return (
    <>
      <Flex pt={{ base: "130px", md: "80px", xl: "80px" }}>
        <Card>
          {loader ? (
            <IsLoading />
          ) : (
            <FormControl>
              <SimpleGrid columns={[1, 1, 2, 3]} spacingX={5}>
                <MultiFileUpload
                  data={[]}
                  handleUploadImage={(val: any) => {
                    handleChangeUploadField("images", val);
                  }}
                  handleUploadComplete={() => {
                    dispatch(actions.doGetList());
                  }}
                  title={`${t("common.form.uploadFile")}`}
                  isRequiredFalse
                />
              </SimpleGrid>
              <SimpleGrid spacingX={5} columns={[1, 1, 2, 4, 5,6]}>
                {list.map((ele) => {
                  return (
                    <Box
                      position="relative"
                      key={ele?._id}
                      w="200px"
                      h="200px"
                      display="flex"
                      alignItems="center"
                      padding={5}
                      overflow={"hidden"}
                    >
                      <Image
                        src={path() + ele.file}
                        alt={ele.file}
                        w="180px"
                        h="180px"
                        objectFit="contain"
                        borderRadius="md"
                        onLoad={() => {
                          URL.revokeObjectURL(ele?.file!);
                        }}
                      />
                      <IconButton
                        icon={<CopyIcon boxSize={4} />}
                        aria-label="Delete image"
                        position="absolute"
                        bottom="10px"
                        right="30px"
                        h={6}
                        minW={6}
                        bg="red.500"
                        color="white"
                        _hover={{ bg: "red.600" }}
                        onClick={() => copyToClipboard(ele?.file)}
                      />
                    </Box>
                  );
                })}
              </SimpleGrid>
            </FormControl>
          )}
        </Card>
      </Flex>
    </>
  );
}
